import React, { Fragment, useEffect, useState } from 'react';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import FsLightbox from 'fslightbox-react';
import Splide from '@splidejs/splide';

const isImageOverflow = (images) => {
    return images.length >= 6;
};

const loadHorizontalSlider = (isMobile, isTablet, images) => {
    const splideElPdp = document.querySelectorAll(
        '.product-detail__thumbnails .splide'
    );
    if (splideElPdp.length > 0) {
        var perPage = isMobile ? 1 : 4;
        var splide = new Splide('.product-detail__thumbnails .splide', {
            wheel: !isMobile,
            wheelSleep: 10,
            waitForTransition: true,
            releaseWheel: false,
            direction: isMobile ? 'ltr' : 'ttb',
            height: isMobile ? '500px' : isImageOverflow(images) ? '500px' : '100%',
            width: isMobile ? '100vw' : '100%',
            perPage: perPage,
            perMove: 1,
            rewind: isMobile ? true : false,
            gap: '10px',
            type: 'slide',
        });
        splide.on('mounted', function () {
            const slides = splide.Components.Slides.getLength();
            const totalPages = Math.ceil(slides / perPage);
            const arrows = splide.Components.Arrows && splide.Components.Arrows.arrows;
            const prevArrow = arrows ? arrows.prev : null;
            const nextArrow = arrows ? arrows.next : null;
            const updateArrows = () => {
                if(isMobile) {
                    if (prevArrow) prevArrow.style.display = '';
                    if (nextArrow) nextArrow.style.display = '';
                    return;
                }
                const currIndex = splide.index;
                if (prevArrow) prevArrow.style.display = currIndex === 0 ? 'none' : '';
                if (nextArrow) nextArrow.style.display = currIndex >= totalPages ? 'none' : '';
            };
            updateArrows();
            splide.on('moved', updateArrows);
        });
        splide.mount();
    }
};

const LightboxImages = (props) => {
    const [toggler, setToggler] = useState(false);
    const [sourceIndex, setSourceIndex] = useState(0);
    const [mainImageIndex, setMainImageIndex] = useState(0);
    const [width, setWidth] = useState(window.innerWidth);
    const images = React.useMemo(() => [...props.images], [props.images]);
    const isMobile = width <= 1024;
    const isTablet = width >= 1024;

    const onClickThumbnail = (index) => {
        if (!isMobile) {
            setMainImageIndex(index);
            const imageEl = document.querySelector(".splide-image.is-clicked");
            if (imageEl) {
                imageEl.classList.remove("is-clicked");
            }
            const targetEl = document.getElementById("splidePdp-slide0" + (index + 1))
            if (targetEl) {
                targetEl.classList.add("is-clicked");
            }
        } else {
            setToggler(!toggler);
            setSourceIndex(index);
            setMainImageIndex(index);
        }
    };

    const onClickMain = (index) => {
        setToggler(!toggler);
        setSourceIndex(index);
        setMainImageIndex(index);
    };

    const handleWindowSizeChange = () => {
        setWidth(window.innerWidth);
    }

    useEffect(() => {
        loadHorizontalSlider(isMobile, isTablet, images);
    }, [isMobile, isTablet, images]);

    useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        }
    }, []);


    if (images && images.length > 0) {
        const mainImageHtml = images[mainImageIndex].html;
        const mainImageLink = images[mainImageIndex].src;
        return (
            <Fragment>
                <div className={`product-images ${isImageOverflow(images) ? 'is-image-overflow' : ''}`} data-slide-elements-count={`${images.length}`}>
                    <div className="product-detail__thumbnails">
                        <div className="product-detail__thumbnails-container splide" id="splidePdp">
                            <div className="splide__track">
                                <ul className="splide__list">
                                    {images.map((image, index) => {
                                        let isFirstIndex = index === 0 ? "is-clicked" : "";
                                        const thumbnailHtml = images[index].html;
                                        return (
                                            <li className={`splide__slide splide-image ${isFirstIndex}`} key={index}>
                                                <div className="product-detail__image-container thumb" key={index}>
                                                    <a
                                                        data-src={image.src}
                                                        href="#"
                                                        itemProp="url"
                                                        className="product-image"
                                                        rel="nofollow"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            onClickThumbnail(index);
                                                        }}
                                                        dangerouslySetInnerHTML={{
                                                            __html: thumbnailHtml
                                                        }}
                                                    ></a>
                                                </div>
                                            </li>
                                        )
                                    })}
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="main-product-image">
                        <figure className={`product-detail__image-container main`}>
                            <a
                                data-src={mainImageLink}
                                href="#"
                                itemProp="url"
                                onClick={(e) => {
                                    e.preventDefault();
                                    onClickMain(mainImageIndex);
                                }}
                                className="product-image"
                                rel="nofollow"
                                dangerouslySetInnerHTML={{
                                    __html: mainImageHtml,
                                }}
                            ></a>
                        </figure>
                    </div>
                </div>
                <FsLightbox
                    toggler={toggler}
                    sourceIndex={sourceIndex}
                    loadOnlyCurrentSource={true}
                    sources={images.map((value, index) => (<img src={value.src} key={index} />))}
                />
            </Fragment>
        );
    }
    else {
        return (<Fragment />);
    }
};

export default LightboxImages;
